import { render } from "./ModalSessionExpired.vue?vue&type=template&id=9c766022&scoped=true"
import script from "./ModalSessionExpired.vue?vue&type=script&lang=js"
export * from "./ModalSessionExpired.vue?vue&type=script&lang=js"

import "./ModalSessionExpired.vue?vue&type=style&index=0&id=9c766022&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c766022"]])

export default __exports__